import React, { Fragment } from 'react';
import PhaseTask from './phase_task';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import ReactTooltip from 'react-tooltip';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import styles from 'flagList.scss';
import S from '../phaseTask.scss';
import TaskIcon from 'components/TaskIcon';
import InstallCompleteModal from '../installCompleteModal';
import { vendorDisplayName } from '../../../../../../../utils';
import { LHI_SOURCES } from 'config/constants';

const MINIMUM_WIDTH = 450;

class InstallComplete extends PhaseTask {
  state = { incorrectLabSheets: [] };

  onClick = () => {
    const { task: { status } } = this.props;
    const incorrectLaborSheets = this.getIncorrectLaborSheets();
    if (status === 'complete') this.toggleStatus();
    else if (incorrectLaborSheets.length === 0 && status === 'incomplete') this.completeTask();
    else this.setState({ modalActive: true });
  }

  getIncorrectLaborSheets = () => {
    const labSheets = this.props.laborSheets.filter(ls => ls.status !== 'Not Payable' && ls.total === 0);
    if (labSheets.length !== 0) this.setState({ incorrectLabSheets: labSheets });
    return labSheets;
  }

  whichVendor = (tag, workroom) => {
    if (tag === 'IMS') return 'VG';
    if (tag === 'IME') return tag;
    return vendorDisplayName(tag, workroom);
  };

  renderToolTip = (phase) => {
    const { source, workroom: { name: workroom = '' } = {} } = phase || {};
    let vendorTag = source;
    if (LHI_SOURCES.includes(source) || source === 'IFI') vendorTag = source === 'IME' ? 'IME' : 'IMS';
    else if (vendorTag !== 'RF') vendorTag = '';
    const vendorDisplay = vendorTag ? this.whichVendor(vendorTag, workroom) : '';
    return (<ReactTooltip id="installToolTip" place="top" effect="solid">
      <span className={styles.tooltipFlagNote}>
        By clicking this task I am confirming that communication has been
        made with the installer to ensure the installation is complete.
        {!!vendorDisplay && <Fragment>
          I also understand this will complete the installation in {vendorDisplay}.
        </Fragment>}
      </span>
    </ReactTooltip>);
  }

  render = () => {
    const { phase, updatePhaseTask: updateTask, task, task: {
            name: taskName = '', status: taskStatus = '' } = {} } = this.props;
    return (<div className={S.taskContainer}>
      <TaskIcon status={taskStatus} />
      <button
        className={S.taskButton}
        data-tip
        data-for="installToolTip"
        onClick={this.onClick}
        disabled={this.isDisabled()}
      >{taskName}</button>
      <MediaQuery minWidth={MINIMUM_WIDTH}>{this.renderToolTip(phase)}</MediaQuery>
      <InstallCompleteModal
        phase={phase}
        task={task}
        active={this.state.modalActive}
        completeTask={this.completeTask}
        onClose={this.handleClose}
        updatePhaseTask={updateTask}
        childHandleTasksClose={this.childHandleTasksClose}
      />
    </div>);
  }
}

InstallComplete.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  laborSheets: PropTypes.array,
};

InstallComplete.defaultProps = { laborSheets: [] };

export const install_complete = connect(state =>
  ({ laborSheets: state.phase.laborSheets.items }),
  { updatePhaseTask, clearValidationErrors })(InstallComplete);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/install_complete.jsx